import { render, staticRenderFns } from "./LocationItem.vue?vue&type=template&id=480910dd&scoped=true&"
import script from "./LocationItem.vue?vue&type=script&lang=ts&"
export * from "./LocationItem.vue?vue&type=script&lang=ts&"
import style0 from "./LocationItem.vue?vue&type=style&index=0&id=480910dd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480910dd",
  null
  
)

export default component.exports